const PENDING_KEY = 'native_first_animal_prompt_pending';

export const firstAnimalPromptDismissedKey = (userId: number) =>
  `native_first_animal_prompt_dismissed_${userId}`;

export function markFirstAnimalPromptPending(): void {
  sessionStorage.setItem(PENDING_KEY, '1');
}

export function consumeFirstAnimalPromptPending(): boolean {
  const pending = sessionStorage.getItem(PENDING_KEY) === '1';
  if (pending) sessionStorage.removeItem(PENDING_KEY);
  return pending;
}

export function isFirstAnimalPromptDismissed(userId: number): boolean {
  return localStorage.getItem(firstAnimalPromptDismissedKey(userId)) === '1';
}

export function dismissFirstAnimalPrompt(userId: number): void {
  localStorage.setItem(firstAnimalPromptDismissedKey(userId), '1');
}

const CORE5_NUDGE_KEY = 'native_carnet_core5_nudge';

export type CarnetCore5Nudge = { animalId: number; name: string };

export function markCarnetCore5Nudge(animalId: number, name: string): void {
  sessionStorage.setItem(
    CORE5_NUDGE_KEY,
    JSON.stringify({ animalId: Number(animalId), name: String(name || '') })
  );
}

export function consumeCarnetCore5Nudge(animalId: number | null): CarnetCore5Nudge | null {
  if (!animalId) return null;
  const raw = sessionStorage.getItem(CORE5_NUDGE_KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as CarnetCore5Nudge;
    if (Number(parsed.animalId) !== Number(animalId)) return null;
    sessionStorage.removeItem(CORE5_NUDGE_KEY);
    return parsed;
  } catch {
    sessionStorage.removeItem(CORE5_NUDGE_KEY);
    return null;
  }
}
